import React from 'react';
import { IIconProps } from './utils';

export const Copy = ({
  fill = 'currentColor',
  height = 30,
  width = 30,
  ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M23.75 18.75C25.1307 18.75 26.25 17.6307 26.25 16.25V6.25C26.25 4.86929 25.1307 3.75 23.75 3.75H13.75C12.3693 3.75 11.25 4.86929 11.25 6.25M16.25 26.25H6.25C4.86929 26.25 3.75 25.1307 3.75 23.75V13.75C3.75 12.3693 4.86929 11.25 6.25 11.25H16.25C17.6307 11.25 18.75 12.3693 18.75 13.75V23.75C18.75 25.1307 17.6307 26.25 16.25 26.25Z"
      stroke={fill}
      strokeLinecap="round"
      strokeWidth="2.5"
    />
  </svg>
);
